<template>
  <div v-show="false">
    <div class="page" ref="container">
      <table
        v-if="listData"
        border="2"
        cellspacing="0"
        align="center"
        style="
          border-collapse: collapse;
          margin: 0 auto;
          width: 20cm;
          height: 27.2cm;
          font-size: 14px;
          text-align: center;
        "
      >
        <caption style="font-weight: bold; font-size: 20px; padding: 10px 0">
          {{
            company
          }}{{
            $t("ClaimsLetter")
          }}
        </caption>
        <tr v-for="(item, index) in listData" :key="item[index]">
          <td style="width: 20%; padding: 10px 0">
            {{ index }}
          </td>
          <td
            style="width: 80%; margin: 0; padding: 0; line-height: 20px"
            :style="
              index == '审核流程' ? 'padding:10px 20px;text-align: left;' : ''
            "
            v-html="item"
          ></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import getLodop from "@/utils/lodop";
export default {
  name: "print",
  props: {
    printData: {
      type: Object,
      default: () => null,
    },
  },
  watch: {
    printData(val) {
      console.log(val);
      this.listData = {};
      for (const key in val) {
        if (key != "company") {
          switch (key) {
            case "customer":
              this.listData["客户名"] = val[key];
              break;
            case "airway_number":
              this.listData["单号"] = val[key];
              break;
            case "refer_code":
              this.listData["转单号"] = val[key];
              break;
            case "country":
              this.listData["目的地国家"] = val[key];
              break;
            case "deliver":
              this.listData["派送代理"] = val[key];
              break;
            case "outbound_time":
              this.listData["出货日期"] = val[key];
              break;
            case "goods_name":
              this.listData["品名"] = val[key];
              break;
            case "quantity":
              this.listData["件数"] = val[key];
              break;
            case "freight":
              this.listData["运费"] = val[key];
              break;
            case "values":
              this.listData["申报价值"] = val[key];
              break;
            case "amount":
              this.listData["总赔偿金额"] = val[key];
              break;
            case "complete_time":
              this.listData["处理日期"] = val[key];
              break;
            case "claim_cause":
              this.listData["赔偿原因"] = val[key];
              break;
            case "review_process":
              this.listData["审核流程"] = val[key];
              break;
          }
        } else {
          this.company = val[key];
        }
      }
      this.$nextTick(() => {
        this.print();
      });
    },
  },
  data() {
    return {
      size: 20,
      listData: null,
      company: "",
    };
  },
  methods: {
    print() {
      // return false;
      let lodop = getLodop(this);
      if (!lodop) {
        return false;
      }
      lodop.PRINT_INIT(this.company + this.$t("ClaimsLetter")); //首先一个初始化语句
      lodop.SET_PRINT_PAGESIZE(1, "210mm", "297mm", ""); //规定纸张大小；使用A4纸
      lodop.SET_PRINT_STYLEA(0, "AlignJustify", false); //ItemType:设置上面的为页眉页脚，每页固定位置输出
      // this.printData.forEach((item, index) => {
      lodop.ADD_PRINT_HTML(
        0,
        0,
        "200mm",
        "285mm",
        this.$refs["container"].outerHTML
      );
      lodop.NEWPAGE();
      // });
      lodop.PREVIEW(); //打印预览
    },
  },
};
</script>

<style lang="less" scoped>
.border {
  border: 1px solid;
}
.center {
  text-align: center;
}
.page {
  width: 21cm;
  min-height: 29.7cm;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  position: relative;
}

@page {
  size: A4;
  margin: 0;
}
@media print {
  .page {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }
}
table {
  border-collapse: collapse; /*去掉双重的border*/
  width: 20cm;
  height: 28.7cm;
  font-size: 14px;
  text-align: center;
}
table tr td:nth-child(1) {
  /* width: auto; */
  width: 20%;
}
table tr td {
  padding: 10px 0;
}
</style>
